import { createFileRoute } from '@tanstack/react-router';
import { BenefitAddPage } from './BenefitAddPage';

export const Route = createFileRoute('/_protected/admin/benefits/add/')({
  component: BenefitAddPage,
});
